import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import getOrders from "../Services/orderService";

// Initial state
const initialState = {
  value: [],
  status: 'idle', // idle | loading | succeeded | failed
  error: null
};

// Thunk to fetch orders
export const fetchOrders = createAsyncThunk('order/fetchOrders', async () => {
  const response = await getOrders();
  return response.orders;
});

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.value = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

// Action creators are generated for each case reducer function
export const { update } = orderSlice.actions;

export default orderSlice.reducer;
